// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-grave {
  --container-margin: 24px;
}

.c-grave__container {
  padding: 32px 24px 0;
}

.c-grave__h1 {
  margin: 0 0 4px 0;
}

/* Image gallery */
.c-grave-slider {
  position: relative;
}

.c-grave-slider .alice-carousel__prev-btn {
  left: 8px;
}

.c-grave-slider .alice-carousel__next-btn {
  right: 8px;
}

.c-grave-slider .alice-carousel__prev-btn,
.c-grave-slider .alice-carousel__next-btn {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.5);
  z-index: 3; /* Above enlarge / full screen button */
}

.c-grave-slider__slide {
  position: relative;
  flex: none;
  height: 440px;
  margin: 0 0 0 8px;
  scroll-snap-align: center;
  border-radius: 8px;
  background: var(--white);
  border: 1px solid var(--light-grey);
}

.c-grave-slider__image {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.c-grave-slider__src {
  align-items: flex-end;
  bottom: 0;
  color: var(--white);
  display: flex;
  left: 0;
  pointer-events: none;
  position: absolute;
  z-index: 2;
  font-size: 8px;
  margin: 8px;
  background: var(--black);
}

.c-grave-slider__desc {
  width: 100%;
  align-items: flex-end;
  bottom: 0;
  color: #fff;
  display: flex;
  left: 0;
  pointer-events: none;
  position: absolute;
  z-index: 2;
  font-size: 16px;
  border-radius: 0 0 8px 8px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 80%, rgba(0, 0, 0, 0) 100%);
}

.c-grave-slider__desc-inner {
  padding: 24px 16px;
}

.c-grave__intro {
  padding: 32px 0;
  margin-bottom: 32px;
}

.c-grave__intro-bg {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  object-fit: cover;
}

.c-grave__intro-img {
  height: 200px;
  object-fit: cover;
}

.c-grave-slider__open {
  background: rgb(1, 1, 1, 0.5);
  height: 36px;
  width: 36px;
  right: 0;
  top: 0;
  border: none;
  position: absolute;
  z-index: 2;
  border-radius: 50%;
  margin: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-grave-slider__open-icon {
  height: 20px;
  width: 20px;
  color: var(--white);
}

.c-grave-slider__exit {
  position: absolute;
  right: 0;
  margin: 12px;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  background: var(--black);
  border: none;
  z-index: 101; /* Keep above all other items. */
}

.c-grave-slider__exit-icon {
  color: var(--white);
}

/* Full Screen Image Gallery */
.c-grave-slider--fs {
  display: none;

  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(1, 1, 1, 0.9);
  z-index: 101; /* Keep above all other items. */
}

.c-grave-slider--fs.is-active {
  display: block;
}

.c-grave-slider--fs .c-grave-slider__slide {
  height: 100vh;
  border-radius: 0;
  background: none;
  border: none;
  margin: 0;
}

.c-grave-slider--fs .c-grave-slider__image {
  border-radius: 0;
  height: unset;
  width: 100%;
  object-fit: contain;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.c-grave-slider--fs .c-grave-slider__desc {
  border-radius: 0;
}

.c-grave-slider--fs .c-grave-slider__open {
  display: none;
}

/* Headline */
.c-grave__headline {
  font-weight: 400;
  background: linear-gradient(90deg, rgba(204, 163, 79, 1) 70%, rgba(152, 117, 46, 1) 100%);
  padding: 8px 24px;
  border-radius: 2px;
  max-width: 70%;
  box-shadow: var(--shadow);
}

.c-grave__headline:before {
  content: '';
  position: absolute;
  width: 5px;
  height: 5px;
  top: 45%;
  left: 8px;
  border-radius: 50% 50%;
  border: 1px solid black;
}

.c-grave__headline:after {
  content: '';
  position: absolute;
  width: 5px;
  height: 5px;
  top: 45%;
  right: 8px;
  border-radius: 50% 50%;
  border: 1px solid black;
}

/* Biography */
.c-grave__bio {
  margin: 24px var(--container-margin) 0;
}

/* Eras Pills */
.c-grave__era-pill {
  position: relative;
  padding: 4px 24px 4px 16px;
  margin: 8px 0;
}

.c-grave__era-icon {
  position: absolute;
  right: 8px;
  width: 16px;
  height: 16x;
}

/* Quiz */
.c-quiz {
  border-radius: 4px;
  background: var(--light-blue);
  padding: 32px 16px;
  min-height: 65vh;

  li {
    list-style: none;
  }
}

.c-quiz__question {
  display: none;
}

.c-quiz__question.is-active {
  display: block;
}

.c-quiz__options {
  padding: 0;
  list-style: none;
}

.c-quiz__option-btn {
  position: relative;
  text-align: left;
  background: white;
  border: 1px solid white;
  border-radius: 4px;
  padding: 16px 12px;
  margin-bottom: 12px;
  width: 100%;
  font-weight: bold;
  box-shadow: var(--shadow);
  color: black;
  font-size: 16px;
}

.c-quiz__option-btn.correct {
  border: 1px solid var(--green);
  color: var(--green);
  background: white;
}

.c-quiz__option-btn.is-clicked.incorrect {
  border: 1px solid var(--red);
  color: var(--red);
}

.c-quiz__progress-outer {
  display: flex;
  gap: 4px;
}

.c-quiz__progress {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-quiz__progress-icon {
  height: 16px;
  width: 16px;
}

.c-quiz__progress--empty {
  background-color: var(--dark-blue);
  opacity: 0.5;
}

.c-quiz__progress--check {
  background-color: var(--green);
}

.c-quiz__progress--x {
  background-color: var(--red);
}

.c-quiz__letter {
  float: left;
  margin-right: 16px;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background-color: var(--dark-grey);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-quiz__mark {
  display: none;
  position: absolute;
  height: 16px;
  width: 16px;
  padding-left: 4px;
  right: 8px;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.c-quiz__mark.is-active {
  display: block;
}

.c-quiz__end-level {
  font-weight: bold;
  text-align: center;
  font-size: 32px;
}

.c-quiz__end--bad {
  color: var(--red);
}

.c-quiz__report {
  background: var(--white);
  border-radius: 4px;
  opacity: 0;
  height: 0;
  overflow: scroll;
}

.c-quiz__score {
  text-align: center;
  font-weight: bold;
}

.c-quiz__score-bar-container {
  --bar-height: 32px;
  width: 200px;
  height: var(--bar-height);
  background-color: var(--white);
  margin: 0 auto;
}

.c-quiz__score-bar {
  height: var(--bar-height);
  background-color: var(--green);
  width: var(--bar-width);
}

.c-quiz__buttons {
  margin: 12px auto;
}

.c-quiz__restart-icon {
  height: 16px;
  width: 16px;
  margin-right: 4px;
}

/* Font Toggle */
.c-font__toggle {
  display: flex;
  align-items: flex-end;
  gap: 6px;
}

.c-font__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.c-font__button {
  padding: 0.5rem;
  line-height: 0;
  font-weight: normal;
  color: black;
  border: 1px solid black;
  border-radius: 2px;
  cursor: pointer;
  background-color: var(--white);
  margin-bottom: 4px;
}

.c-font__button.small {
  height: 28px;
  width: 28px;
  font-size: 16px;
}

.c-font__button.large {
  height: 32px;
  width: 32px;
  font-size: 20px;
}

.c-font__button.active {
  background: var(--light-blue);
  border: 1px solid var(--dark-blue);
}
`, "",{"version":3,"sources":["webpack://./src/styles/grave.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU,EAAE,uCAAuC;AACrD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,aAAa;EACb,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;;EAEb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,8BAA8B;EAC9B,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,yFAAyF;EACzF,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,UAAU;EACV,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;;EAEhB;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,MAAM;EACN,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC","sourcesContent":[".c-grave {\n  --container-margin: 24px;\n}\n\n.c-grave__container {\n  padding: 32px 24px 0;\n}\n\n.c-grave__h1 {\n  margin: 0 0 4px 0;\n}\n\n/* Image gallery */\n.c-grave-slider {\n  position: relative;\n}\n\n.c-grave-slider .alice-carousel__prev-btn {\n  left: 8px;\n}\n\n.c-grave-slider .alice-carousel__next-btn {\n  right: 8px;\n}\n\n.c-grave-slider .alice-carousel__prev-btn,\n.c-grave-slider .alice-carousel__next-btn {\n  width: 36px;\n  height: 36px;\n  background: rgba(255, 255, 255, 0.5);\n  z-index: 3; /* Above enlarge / full screen button */\n}\n\n.c-grave-slider__slide {\n  position: relative;\n  flex: none;\n  height: 440px;\n  margin: 0 0 0 8px;\n  scroll-snap-align: center;\n  border-radius: 8px;\n  background: var(--white);\n  border: 1px solid var(--light-grey);\n}\n\n.c-grave-slider__image {\n  position: absolute;\n  height: 100%;\n  left: 0;\n  top: 0;\n  width: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.c-grave-slider__src {\n  align-items: flex-end;\n  bottom: 0;\n  color: var(--white);\n  display: flex;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  z-index: 2;\n  font-size: 8px;\n  margin: 8px;\n  background: var(--black);\n}\n\n.c-grave-slider__desc {\n  width: 100%;\n  align-items: flex-end;\n  bottom: 0;\n  color: #fff;\n  display: flex;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  z-index: 2;\n  font-size: 16px;\n  border-radius: 0 0 8px 8px;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 80%, rgba(0, 0, 0, 0) 100%);\n}\n\n.c-grave-slider__desc-inner {\n  padding: 24px 16px;\n}\n\n.c-grave__intro {\n  padding: 32px 0;\n  margin-bottom: 32px;\n}\n\n.c-grave__intro-bg {\n  position: absolute;\n  height: 100%;\n  left: 0;\n  top: 0;\n  width: 100%;\n  object-fit: cover;\n}\n\n.c-grave__intro-img {\n  height: 200px;\n  object-fit: cover;\n}\n\n.c-grave-slider__open {\n  background: rgb(1, 1, 1, 0.5);\n  height: 36px;\n  width: 36px;\n  right: 0;\n  top: 0;\n  border: none;\n  position: absolute;\n  z-index: 2;\n  border-radius: 50%;\n  margin: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.c-grave-slider__open-icon {\n  height: 20px;\n  width: 20px;\n  color: var(--white);\n}\n\n.c-grave-slider__exit {\n  position: absolute;\n  right: 0;\n  margin: 12px;\n  border-radius: 50%;\n  height: 48px;\n  width: 48px;\n  background: var(--black);\n  border: none;\n  z-index: 101; /* Keep above all other items. */\n}\n\n.c-grave-slider__exit-icon {\n  color: var(--white);\n}\n\n/* Full Screen Image Gallery */\n.c-grave-slider--fs {\n  display: none;\n\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba(1, 1, 1, 0.9);\n  z-index: 101; /* Keep above all other items. */\n}\n\n.c-grave-slider--fs.is-active {\n  display: block;\n}\n\n.c-grave-slider--fs .c-grave-slider__slide {\n  height: 100vh;\n  border-radius: 0;\n  background: none;\n  border: none;\n  margin: 0;\n}\n\n.c-grave-slider--fs .c-grave-slider__image {\n  border-radius: 0;\n  height: unset;\n  width: 100%;\n  object-fit: contain;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n.c-grave-slider--fs .c-grave-slider__desc {\n  border-radius: 0;\n}\n\n.c-grave-slider--fs .c-grave-slider__open {\n  display: none;\n}\n\n/* Headline */\n.c-grave__headline {\n  font-weight: 400;\n  background: linear-gradient(90deg, rgba(204, 163, 79, 1) 70%, rgba(152, 117, 46, 1) 100%);\n  padding: 8px 24px;\n  border-radius: 2px;\n  max-width: 70%;\n  box-shadow: var(--shadow);\n}\n\n.c-grave__headline:before {\n  content: '';\n  position: absolute;\n  width: 5px;\n  height: 5px;\n  top: 45%;\n  left: 8px;\n  border-radius: 50% 50%;\n  border: 1px solid black;\n}\n\n.c-grave__headline:after {\n  content: '';\n  position: absolute;\n  width: 5px;\n  height: 5px;\n  top: 45%;\n  right: 8px;\n  border-radius: 50% 50%;\n  border: 1px solid black;\n}\n\n/* Biography */\n.c-grave__bio {\n  margin: 24px var(--container-margin) 0;\n}\n\n/* Eras Pills */\n.c-grave__era-pill {\n  position: relative;\n  padding: 4px 24px 4px 16px;\n  margin: 8px 0;\n}\n\n.c-grave__era-icon {\n  position: absolute;\n  right: 8px;\n  width: 16px;\n  height: 16x;\n}\n\n/* Quiz */\n.c-quiz {\n  border-radius: 4px;\n  background: var(--light-blue);\n  padding: 32px 16px;\n  min-height: 65vh;\n\n  li {\n    list-style: none;\n  }\n}\n\n.c-quiz__question {\n  display: none;\n}\n\n.c-quiz__question.is-active {\n  display: block;\n}\n\n.c-quiz__options {\n  padding: 0;\n  list-style: none;\n}\n\n.c-quiz__option-btn {\n  position: relative;\n  text-align: left;\n  background: white;\n  border: 1px solid white;\n  border-radius: 4px;\n  padding: 16px 12px;\n  margin-bottom: 12px;\n  width: 100%;\n  font-weight: bold;\n  box-shadow: var(--shadow);\n  color: black;\n  font-size: 16px;\n}\n\n.c-quiz__option-btn.correct {\n  border: 1px solid var(--green);\n  color: var(--green);\n  background: white;\n}\n\n.c-quiz__option-btn.is-clicked.incorrect {\n  border: 1px solid var(--red);\n  color: var(--red);\n}\n\n.c-quiz__progress-outer {\n  display: flex;\n  gap: 4px;\n}\n\n.c-quiz__progress {\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.c-quiz__progress-icon {\n  height: 16px;\n  width: 16px;\n}\n\n.c-quiz__progress--empty {\n  background-color: var(--dark-blue);\n  opacity: 0.5;\n}\n\n.c-quiz__progress--check {\n  background-color: var(--green);\n}\n\n.c-quiz__progress--x {\n  background-color: var(--red);\n}\n\n.c-quiz__letter {\n  float: left;\n  margin-right: 16px;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background-color: var(--dark-grey);\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.c-quiz__mark {\n  display: none;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  padding-left: 4px;\n  right: 8px;\n  top: 0;\n  bottom: 0;\n  margin: auto 0;\n}\n\n.c-quiz__mark.is-active {\n  display: block;\n}\n\n.c-quiz__end-level {\n  font-weight: bold;\n  text-align: center;\n  font-size: 32px;\n}\n\n.c-quiz__end--bad {\n  color: var(--red);\n}\n\n.c-quiz__report {\n  background: var(--white);\n  border-radius: 4px;\n  opacity: 0;\n  height: 0;\n  overflow: scroll;\n}\n\n.c-quiz__score {\n  text-align: center;\n  font-weight: bold;\n}\n\n.c-quiz__score-bar-container {\n  --bar-height: 32px;\n  width: 200px;\n  height: var(--bar-height);\n  background-color: var(--white);\n  margin: 0 auto;\n}\n\n.c-quiz__score-bar {\n  height: var(--bar-height);\n  background-color: var(--green);\n  width: var(--bar-width);\n}\n\n.c-quiz__buttons {\n  margin: 12px auto;\n}\n\n.c-quiz__restart-icon {\n  height: 16px;\n  width: 16px;\n  margin-right: 4px;\n}\n\n/* Font Toggle */\n.c-font__toggle {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.c-font__container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.c-font__button {\n  padding: 0.5rem;\n  line-height: 0;\n  font-weight: normal;\n  color: black;\n  border: 1px solid black;\n  border-radius: 2px;\n  cursor: pointer;\n  background-color: var(--white);\n  margin-bottom: 4px;\n}\n\n.c-font__button.small {\n  height: 28px;\n  width: 28px;\n  font-size: 16px;\n}\n\n.c-font__button.large {\n  height: 32px;\n  width: 32px;\n  font-size: 20px;\n}\n\n.c-font__button.active {\n  background: var(--light-blue);\n  border: 1px solid var(--dark-blue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
